import { render, staticRenderFns } from "./editUsers.vue?vue&type=template&id=206b3efc&"
import script from "./editUsers.vue?vue&type=script&lang=ts&"
export * from "./editUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports